import { render, staticRenderFns } from "./DNLLogo.vue?vue&type=template&id=38bbd3ef&scoped=true&"
import script from "./DNLLogo.vue?vue&type=script&lang=js&"
export * from "./DNLLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bbd3ef",
  null
  
)

export default component.exports